// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-actions {
  position: fixed;
  right: 1rem;
  bottom: 1rem;

  display: flex;
  gap: 8px;
}

.floating-action-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  height: 40px;
  padding: 0 18px;

  border-radius: 0px;
  border: none;
  cursor: pointer;

  background: #c44a4a;
  color: #ffffff;

  font-size: 15px;
  font-weight: 500;
  line-height: 1;

  margin-bottom: 20px;
  margin-right: 18px;
}

.floating-action-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: 15px;
  line-height: 1;
}

.floating-action-button:hover {
  background: #cf2f2f;
}

.floating-action-button:active {
  background: #c83636;
  transform: translateY(1px);
}

.floating-action-button:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: 2px;
}

/**/

/* Desktop */
.floating-action-label {
    display: inline;
}

/* @media (max-width: 1199px) {

    .floating-action-button {
        width: 48px;
        height: 48px;
        padding: 0;
        justify-content: center;
    }

    .floating-action-icon {
        margin: 0;
        font-size: 20px;
    }
}

@media (max-width: 767px) {
    .floating-action-button {
        width: 52px;
        height: 52px;
    }

    .floating-action-icon {
        font-size: 22px;
    }
} */`, "",{"version":3,"sources":["webpack://./src/web/component/FloatingActions/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;;EAET,YAAY;EACZ,eAAe;;EAEf,kBAAkB;EAClB,YAAY;EACZ,eAAe;;EAEf,mBAAmB;EACnB,cAAc;;EAEd,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,GAAG;;AAEH,YAAY;AACZ;IACI,eAAe;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;GAwBG","sourcesContent":[".floating-actions {\r\n  position: fixed;\r\n  right: 1rem;\r\n  bottom: 1rem;\r\n\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.floating-action-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n\r\n  height: 40px;\r\n  padding: 0 18px;\r\n\r\n  border-radius: 0px;\r\n  border: none;\r\n  cursor: pointer;\r\n\r\n  background: #c44a4a;\r\n  color: #ffffff;\r\n\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  line-height: 1;\r\n\r\n  margin-bottom: 20px;\r\n  margin-right: 18px;\r\n}\r\n\r\n.floating-action-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  font-size: 15px;\r\n  line-height: 1;\r\n}\r\n\r\n.floating-action-button:hover {\r\n  background: #cf2f2f;\r\n}\r\n\r\n.floating-action-button:active {\r\n  background: #c83636;\r\n  transform: translateY(1px);\r\n}\r\n\r\n.floating-action-button:focus-visible {\r\n  outline: 2px solid rgba(255, 255, 255, 0.8);\r\n  outline-offset: 2px;\r\n}\r\n\r\n/**/\r\n\r\n/* Desktop */\r\n.floating-action-label {\r\n    display: inline;\r\n}\r\n\r\n/* @media (max-width: 1199px) {\r\n\r\n    .floating-action-button {\r\n        width: 48px;\r\n        height: 48px;\r\n        padding: 0;\r\n        justify-content: center;\r\n    }\r\n\r\n    .floating-action-icon {\r\n        margin: 0;\r\n        font-size: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .floating-action-button {\r\n        width: 52px;\r\n        height: 52px;\r\n    }\r\n\r\n    .floating-action-icon {\r\n        font-size: 22px;\r\n    }\r\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
